var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header_button"},[_c('BaseIcon',{staticClass:"header_icon mr-1",attrs:{"name":"shopping-cart","width":"20","height":"20"}}),_c('div',{staticClass:"itemsQuantity"},[_vm._v("("+_vm._s(_vm.itemsQuantity)+")")]),_c('div',{staticClass:"itemsTotal"},[_vm._v(_vm._s(_vm._f("currency")(_vm.total,_vm.cSymb)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }